import { api } from "../../http";

async function GetFindDataRRIM(rrim) {
  try {
    
    const data = await api.get(`/rrim/find-export/${rrim}`);
    
    return data;


  } catch (e) {
    console.log(e.message);
  }
}

export { GetFindDataRRIM };
